import {createContext, useContext} from 'react'

import type {PanelFragment} from '@sdox/api'

interface PanelContextState {
  panels: PanelFragment[]
}

export const PanelContext = createContext<PanelContextState>({panels: []})

export const usePanelIds = () => {
  const value = useContext(PanelContext)
  if (value === undefined) {
    throw new Error('PanelContext must be defined')
  }
  return value.panels.map((panel) => panel.id)
}

export const usePanels = (): PanelFragment[] => {
  const value = useContext(PanelContext)
  if (value === undefined) {
    throw new Error('PanelContext must be defined')
  }
  return value.panels
}
